export default __webpack_public_path__ + "static/media/_DSC0152.3ba98eec.JPG";